import React from 'react';

// Right-hand resume outline: per-section fill status and entry counts.
// Phase 2 replaces this panel with the live PDF preview.
// When `embedded` is true, renders only the inner list (no aside/card/heading —
// the parent PreviewPanel supplies the chrome). Default false keeps standalone rendering.
const OutlinePanel = ({ sections, onNavigate, embedded = false }) => {
    const list = (
        <ul className="space-y-2">
            {sections.map(({ key, label, filled, count }) => (
                <li key={key}>
                    <button onClick={() => onNavigate(key)} className="w-full flex items-center justify-between text-sm group">
                        <span className={filled ? 'text-neutral-200 group-hover:text-white' : 'text-neutral-500 group-hover:text-neutral-300'}>
                            {label}
                        </span>
                        <span className="text-xs text-neutral-500">
                            {count !== null ? `${count} ${count === 1 ? 'entry' : 'entries'}` : (filled ? '✓' : 'empty')}
                        </span>
                    </button>
                </li>
            ))}
        </ul>
    );

    if (embedded) return list;

    return (
        <aside className="hidden lg:block lg:sticky lg:top-24 lg:w-64 lg:shrink-0">
            <div className="rounded-xl border border-white/10 bg-[#0b0e14]/60 p-5">
                <div className="flex items-center gap-2 mb-4">
                    <span className="h-1.5 w-1.5 rounded-full bg-cyan-400" />
                    <h3 className="text-[11px] font-semibold uppercase tracking-[0.18em] text-neutral-400">Resume outline</h3>
                </div>
                {list}
            </div>
        </aside>
    );
};

export default OutlinePanel;
